<template>
 <div class="help-third-page">
  <div :class="lang === 'en' ? 'help-third-page-image-content-en' : 'help-third-page-image-content'" >
  </div>
  <div class="help-third-page-text-content" data-langname="lb_help_3">
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      lang: this.$route.query.lang,
    };
  }
}
</script>
